import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { ReciclagemProvider } from '../../../providers/reciclagem/reciclagem.provider';
import { ReciboProvider } from '../../../providers/reciclagem/recibo.provider';
import { ParticipacaoProvider } from '../../../providers/participacao/partipacao.provider';

import { ReciclagemHistoricoPage } from './reciclagem-historico';
import { PipesModule } from '../../../pipes/pipes.module';


@NgModule({
  declarations: [
    ReciclagemHistoricoPage
  ],
  imports: [
    IonicPageModule.forChild(ReciclagemHistoricoPage),
    PipesModule,
  ],
  providers:[
    ReciclagemProvider, ReciboProvider, ParticipacaoProvider
  ]
})
export class ReciclagemHistoricoModule {}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem-historico/reciclagem-historico.module.ts